module.exports = __webpack_public_path__ + "img/sao_tome_and_principe.5aaf12e.webp";